import { createContext } from "react";
import type { BootstrapResponse } from "@/lib/bootstrap-types";

export interface SessionState {
  /** Full session data from bootstrap. null while loading or if not authenticated. */
  session: BootstrapResponse | null;
  /** Whether the session is still loading. */
  isSessionLoading: boolean;
  /** Refresh the session data from the server. */
  refreshSession: () => Promise<void>;
}

export const SessionContext = createContext<SessionState | undefined>(
  undefined,
);
